import { render, staticRenderFns } from "./TripDashboard.vue?vue&type=template&id=2e215748&"
import script from "./TripDashboard.vue?vue&type=script&lang=js&"
export * from "./TripDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports